import { ListViewRowWrapper } from '@ami/react/core';
import PropTypes from 'prop-types';
import React from 'react';
import DealerUserSimpleTableRow from '../../dealer-users/components/DealerUserSimpleTableRow';

const DealerUserSimpleTable = ({
  dealerUsers,
  onOpenEdit,
  loading,
  onBottomScroll,
}) => {
  const rows = dealerUsers.map((dealerUser) => (
    <DealerUserSimpleTableRow
      dealerUser={dealerUser}
      key={dealerUser.userId}
      onOpenEdit={onOpenEdit}
    />
  ));
  return (
    <table className="table table-striped table-hover">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Dealer Group</th>
          <th>Dealer Branch</th>
          <th>Has registered?</th>
          <th>Is retired?</th>
        </tr>
      </thead>
      <tbody>
        <ListViewRowWrapper
          rows={rows}
          numberOfColumns={6}
          loading={loading}
          onBottomScroll={onBottomScroll}
        />
      </tbody>
    </table>
  );
};

DealerUserSimpleTable.propTypes = {
  dealerUsers: PropTypes.array.isRequired,
  onOpenEdit: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  onBottomScroll: PropTypes.func.isRequired,
};

export default DealerUserSimpleTable;
